import { makeEntityScaffold } from '@classpass/saga-tools';
import { deepExtract } from 'helpers/deep';

export const taxRate = makeEntityScaffold(
  'SAGA.API.TAX_RATE',
  (client, msaId, postalCode) =>
    client.taxes
      .getAmount({
        billing_info: { address: { postal_code: String(postalCode) } },
        msa_id: parseInt(msaId, 10),
      })
      .then(data => data.rate),
  { defaultKey: [1, 2] }
);

export const paymentTypes = makeEntityScaffold(
  'SAGA.API.PAYMENT_TYPES',
  (client, countryCode) => client.transactions.paymentTypes(countryCode).then(data => data.data),
  { defaultKey: [1] }
);

export const userBillingDetails = makeEntityScaffold(
  'SAGA.API.BILLING_DETAILS',
  (client, userId) =>
    client.subscription.getV2(userId, { extended: true }).then(data => {
      const billingInfo = deepExtract('data.card', data) || deepExtract('data.stripe_source', data);

      if (!billingInfo) {
        return null;
      }

      return {
        name: billingInfo.name,
        lastFour: billingInfo.last_4,
        expMonth: billingInfo.exp_month,
        expYear: billingInfo.exp_year,
        type: billingInfo.type,
      };
    }),
  { defaultKey: 1 }
);
